var getConfigFromDom;

module.exports = getConfigFromDom = function(id) {
  var elt, error, text;
  if (id == null) {
    id = 'domConfig';
  }
  elt = document.getElementById(id);
  if (!elt) {
    return {};
  }
  text = elt.textContent || elt.innerText;
  try {
    return JSON.parse(text);
  } catch (error1) {
    error = error1;
    error.message += '\n     Attempted to parse: ' + text;
    throw error;
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvZ3JvdXBvbl9tb2R1bGVzL2dldENvbmZpZ0Zyb21Eb20uY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvZ3JvdXBvbl9tb2R1bGVzL2dldENvbmZpZ0Zyb21Eb20uY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLElBQUE7O0FBQUEsTUFBTSxDQUFDLE9BQVAsR0FBaUIsZ0JBQUEsR0FBbUIsU0FBQyxFQUFEO0FBQ2xDLE1BQUE7O0lBRG1DLEtBQUs7O0VBQ3hDLEdBQUEsR0FBTSxRQUFRLENBQUMsY0FBVCxDQUF3QixFQUF4QjtFQUNOLElBQWEsQ0FBQyxHQUFkO0FBQUEsV0FBTyxHQUFQOztFQUNBLElBQUEsR0FBTyxHQUFHLENBQUMsV0FBSixJQUFtQixHQUFHLENBQUM7QUFJOUI7V0FDRSxJQUFJLENBQUMsS0FBTCxDQUFXLElBQVgsRUFERjtHQUFBLGNBQUE7SUFFTTtJQUNKLEtBQUssQ0FBQyxPQUFOLElBQWlCLDZCQUFBLEdBQWdDO0FBQ2pELFVBQU0sTUFKUjs7QUFQa0MifQ==
